import { getImageProps } from 'next/image';

interface Props {
  image: string;
  mobileImage: string;
  className?: string;
  fill?: boolean;
  common: { alt: string; width: number; height: number };
}

function Picture(props: Props) {
  const { image, mobileImage, className, fill, common } = props;
  const {
    props: { srcSet: mobile },
  } = getImageProps({
    src: mobileImage,
    fill,
    width: !fill ? common.width : undefined,
    height: !fill ? common.height : undefined,
    alt: common.alt,
  });

  const {
    props: { srcSet: desktop, ...rest },
  } = getImageProps({
    src: image,
    fill,
    width: !fill ? common.width : undefined,
    height: !fill ? common.height : undefined,
    alt: common.alt,
  });
  return (
    <picture>
      <source media='(min-width: 600px)' srcSet={desktop} />
      <source srcSet={mobile} />
      <img {...rest} className={className} alt={common.alt} />
    </picture>
  );
}

export default Picture;
